import axios from "src/axios/axios";
import useAuth from "./useAuth";
import jwt from 'jwt-decode'
import { decryptObject } from "src/lib/crypt";

export type JWT = {
    username: string;
    password: string;
    expiry: string;
}

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        try {
            let token = '';
            if(process.env.REACT_APP_SECRET) {
                let jwt = window.localStorage.getItem('jwt');                
                if(jwt){
                    const dc = decryptObject(jwt, process.env.REACT_APP_SECRET) as JWT;
                    if(dc.expiry){
                        if(new Date() > new Date(dc.expiry)){
                            //Token Expired
                            window.localStorage.removeItem('jwt')
                            throw new Error('Token expired');
                        }
                    }

                    const { data } = await axios.post('authenticate', dc)
                    if(data.errorcode === 0){
                        setAuth({status:'authenticated', data: data.object})
                        token = data.token;
                    }
                }
            }
            return token;
        } catch (error) {
            console.error(error)
        }
    }

    return refresh
}

export default useRefreshToken